import { useEffect, useState } from 'react'
import { throttle } from 'lodash'

export const useWindowEvent = (event, callback) => {
    useEffect(() => {
        window.addEventListener(event, callback)
        return () => window.removeEventListener(event, callback)
    }, [event, callback])
}

export const useMouseUp = callback => {
    return useWindowEvent('mouseup', callback)
}

export const useMouseDown = callback => {
    return useWindowEvent('mousedown', callback)
}

export const useMousePosition = (wait = 0) => {
    const [position, setPosition] = useState({ x: 0, y: 0 })

    useEffect(() => {
        const setFromEvent = e => setPosition({ x: e.clientX, y: e.clientY })
        window.addEventListener('mousemove', throttle(setFromEvent, wait))

        return () => {
            window.removeEventListener('mousemove', setFromEvent)
        }
    }, [])

    return position
}
